/** CoStar.Api.EnterpriseSub.Lookup.FilterElementType */
export var FilterElementType;
(function (FilterElementType) {
    FilterElementType[FilterElementType["AttachmentTypeDescription"] = 0] = "AttachmentTypeDescription";
    FilterElementType[FilterElementType["BuildingClass"] = 1] = "BuildingClass";
    FilterElementType[FilterElementType["BuildOutConditionType"] = 2] = "BuildOutConditionType";
    FilterElementType[FilterElementType["BuildOutType"] = 3] = "BuildOutType";
    FilterElementType[FilterElementType["BuildOutStatusType"] = 4] = "BuildOutStatusType";
    FilterElementType[FilterElementType["ConstructionStatus"] = 5] = "ConstructionStatus";
    FilterElementType[FilterElementType["ContiguousSpaceType"] = 6] = "ContiguousSpaceType";
    FilterElementType[FilterElementType["EpcRating"] = 7] = "EpcRating";
    FilterElementType[FilterElementType["LeaseDealSourceGroup"] = 8] = "LeaseDealSourceGroup";
    FilterElementType[FilterElementType["LeaseDealType"] = 9] = "LeaseDealType";
    FilterElementType[FilterElementType["LeaseDealRentType"] = 10] = "LeaseDealRentType";
    FilterElementType[FilterElementType["LeaseDealStatus"] = 11] = "LeaseDealStatus";
    FilterElementType[FilterElementType["LeaseType"] = 12] = "LeaseType";
    FilterElementType[FilterElementType["LeedType"] = 13] = "LeedType";
    FilterElementType[FilterElementType["PropertyStatus"] = 14] = "PropertyStatus";
    FilterElementType[FilterElementType["PropertyType"] = 15] = "PropertyType";
    FilterElementType[FilterElementType["PropertyTypeFiltered"] = 16] = "PropertyTypeFiltered";
    FilterElementType[FilterElementType["SpaceLayoutType"] = 17] = "SpaceLayoutType";
    FilterElementType[FilterElementType["ServiceTypeText"] = 18] = "ServiceTypeText";
    FilterElementType[FilterElementType["SpacePositionType"] = 19] = "SpacePositionType";
    FilterElementType[FilterElementType["SpaceType"] = 20] = "SpaceType";
    FilterElementType[FilterElementType["SpaceTypeCategory"] = 21] = "SpaceTypeCategory";
    FilterElementType[FilterElementType["SpaceUse"] = 22] = "SpaceUse";
    FilterElementType[FilterElementType["SpaceUseCategory"] = 23] = "SpaceUseCategory";
    FilterElementType[FilterElementType["SharingPermissionType"] = 24] = "SharingPermissionType";
    FilterElementType[FilterElementType["LeaseDealSourceType"] = 25] = "LeaseDealSourceType";
    FilterElementType[FilterElementType["UseClass"] = 26] = "UseClass";
})(FilterElementType || (FilterElementType = {}));
